export default {
  label: 'Chatta con il nostro team',
  label_unread: 'Chatta con il nostro team, {{count}} nuovi',
};
